<template>
    <button @click="close">

    </button>
</template>

<script>
  import {popups} from "../../mixins/popups";

  export default {
    name: 'closeBtn',
    props: {
      delBtn: {
        type: Boolean,
        required: false,
        default: false
      },
      setBtn:  {
        type: Boolean,
        required: false,
        default: false
      }
    },
    mixins: [popups],
    methods: {
      close() {
        if (!this.delBtn && !this.setBtn) {
          this.closeAll()
        } else if (this.delBtn && !this.setBtn) {
          this.closeDel()
        } else if (!this.delBtn && this.setBtn) {
          this.closeSet()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  button {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.5;
    transition: $anim;

    &:hover, &:focus {
      opacity: 1;
    }

    &::before, &::after {
      content: '';
      position: absolute;
      width: 15px;
      height: 2px;
      background: $darkBlue;
      /*top: 7px;*/
      /*left: 1px;*/
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }

  .static {
    position: relative;
    width: 16px;
    top: 0;
    left: 0;
    height: 16px;
  }
</style>
